import {
    select,
    cancel,
    takeEvery,
} from 'redux-saga/effects'

import {
    focusPrompt,
} from 'common/modules/arbiter/sagas/frameUtilities'

import Loader from 'common/modules/loader'
import Internal from 'common/modules/internal'

function* login() {
    const state = yield select()

    if (
        state?._network.refresh_token.default
        && state?.loader.user
    ) {
        return
    }

    const awaitWizardActionType = 'AWAIT_LOGIN_WIZARD'

    const awaitAction = yield Internal.creators.sendMessage({
        payload: {
            target: 'pico_arbiter',
            type: awaitWizardActionType,
        },
    })

    yield focusPrompt('/login', {
        submitActionType: awaitAction.type,
        submitPayload: JSON.stringify(awaitAction.payload),
    })

    const task = yield takeEvery(
        awaitWizardActionType,
        function* checkForRefreshToken() {
            const { _network } = yield select()

            if (_network?.refresh_token?.default) {
                yield cancel(task)
            }
        },
    )

    const onSendGetLoaderSuccess = yield takeEvery(
        Internal.types.INTERNAL_SEND_MESSAGE,
        function* checkSendLoader({ payload }) {
            if (
                payload?.type === Loader.types.GET_LOADER_SUCCESS
                && payload?.payload?.scope === 'user'
            ) {
                yield cancel(onSendGetLoaderSuccess)
            }
        },
    )

    const loaderTask = yield takeEvery(
        Loader.types.GET_LOADER_SUCCESS,
        function* checkForUserLoader() {
            const { loader } = yield select()

            if (loader.user) {
                yield cancel(loaderTask)
            }
        },
    )
}

const awaitWizard = {
    login,
}

export default awaitWizard
